import { Component, Inject, isDevMode } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageFile } from '@lib/models/generated/graphql';
import { DocumentsService, FicheStorageFile } from '@lib/services/documents.service';
import {
  AdminConfig,
  AdminConfigService,
} from 'projects/fiche-conseil-backoffice/src/app/services/admin-config.service';

@Component({
  selector: 'app-add-legacy-doc-dialog',
  templateUrl: './add-legacy-doc-dialog.component.html',
  styleUrls: ['./add-legacy-doc-dialog.component.scss'],
})
export class AddLegacyDocDialogComponent {
  isloading: boolean = false;
  files: FicheStorageFile[] | null = [];
  coaId: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { ficheConfig: AdminConfig },
    private dialogRef: MatDialogRef<AddLegacyDocDialogComponent>,
    private documentService: DocumentsService,
    private adminConfigService: AdminConfigService
  ) {}

  ngOnInit(): void {
    this.coaId = this.data.ficheConfig.conditionsOfApplicability.id;
    this.files =
      this.data.ficheConfig.conseilConfig?.legacyDocumentsDetails?.map(this.mapStorageFiletoFicheStorageFile) ?? [];
  }

  async onValid() {
    this.isloading = true;
    try {
      const existingFileIds = this.files?.map(file => file.storageFile?.id).filter(id => id !== undefined) as string[];
      const filesToUpload = this.files?.filter(f => !f.storageFile) ?? [];
      const uploaded = await this.documentService.uploadFicheStorageFiles(filesToUpload);
      const newFileIds: string[] = uploaded
        .map(file => file.storageFile?.id)
        .filter(id => id !== undefined) as string[];

      const legacyFileIds = [...existingFileIds, ...newFileIds];
      await this.adminConfigService.createLegacyFilesConfig(this.coaId, legacyFileIds);
      this.dialogRef.close(this.files);
    } catch (error) {
      if (isDevMode()) {
        console.log('error: ', error);
      }
    } finally {
      this.isloading = false;
    }
  }

  deleteFile(fileToDelete: FicheStorageFile) {
    this.files = this.files?.filter(file => file.name !== fileToDelete.name) ?? null;
  }

  mapStorageFiletoFicheStorageFile(storageFile: StorageFile): FicheStorageFile {
    const file = new FicheStorageFile([], storageFile?.fileName, {
      type: storageFile?.fileType,
    });
    file.storageFile = storageFile;
    return file;
  }

  onFileClick(file: FicheStorageFile) {
    if (file.storageFile) {
      this.documentService.displayStorageFileInNewTab(file.storageFile);
      return;
    }
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
  }
}
